module.exports = __webpack_public_path__ + "assets/img/angles.452c9731.png";